import { Outlet } from 'react-router-dom';

import { Callback } from './Callback';
import { Login } from './Login';

const oktaRoutes = {
  path: 'okta',
  element: <Outlet />,
  children: [
    {
      path: ':path',
      element: <Outlet />,
      children: [
        {
          path: 'callback',
          element: <Callback />,
        },
        {
          path: 'login',
          element: <Login />,
        },
      ],
    },
  ],
};

export { oktaRoutes };
